import type { RouteInput } from "@mailhand/core/api";
import { useApi } from "../../app/services.js";
import { useTenant } from "../../app/tenant.js";
import { useTask } from "../../app/useTask.js";

export type TenantPatchBody = RouteInput<"tenantPatch">;

/** PATCH /tenant, then show the answer everywhere the tenant is read. */
export function usePatchTenant(): { busy: boolean; patch: (body: TenantPatchBody, successMessage: string) => Promise<boolean> } {
  const api = useApi();
  const { setView } = useTenant();
  const task = useTask();
  async function patch(body: TenantPatchBody, successMessage: string): Promise<boolean> {
    return task.run(async () => { setView(await api.call("tenantPatch", { body })); }, successMessage);
  }
  return { busy: task.busy, patch };
}
